<script setup lang="ts">
import { X } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { Input } from '@/components/ui/input'
import { usePCSSearchInput } from '@/services/usePCSSearchInput'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

const { t } = useI18n()
const {
	inputValue,
	shouldShowComponent,
	isInputNotEmpty,
	navigateToSearch,
	clearInputValue,
} = usePCSSearchInput()
</script>

<template>
	<div class="relative flex-1" v-if="shouldShowComponent">
		<Input
			v-model="inputValue"
			@keyup.enter="navigateToSearch"
			type="text"
			:placeholder="t('pcs_search_placeholder')"
			class="hidden rounded-full border-n-100 py-[10px] pl-24px pr-[100px] text-black lg:flex"
		></Input>

		<div
			v-if="isInputNotEmpty"
			@click="clearInputValue"
			class="absolute right-[58px] top-1/2 hidden -translate-y-1/2 cursor-pointer rounded-full p-8px hover:bg-n-100 lg:block"
		>
			<X class="h-16px w-16px" />
		</div>

		<div
			@click="navigateToSearch"
			class="absolute right-12px top-1/2 hidden h-32px w-32px -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full bg-o-500 hover:bg-o-600 lg:flex"
		>
			<BaseIcon name="search-v2" class="h-16px w-16px fill-white" />
		</div>
	</div>
</template>
